import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import {  } from '@theme/utilities';

/** @typedef {typeof globalThis} Window */

class SkioPlanPickerComponent extends Component {
  #variantsData = JSON.parse(this.querySelector('[data-variants-json]')?.textContent)

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.variantUpdate, (e) => this.onVariantUpdate(e.detail.resource));

    this.refs.purchaseType.forEach(input => {
      input.addEventListener('input', this.onPurchaseTypeChange.bind(this))
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.refs.purchaseType.forEach(input => {
      input.removeEventListener('input', this.onPurchaseTypeChange.bind(this))
    });
  }

  onPurchaseTypeChange(e) {
    const purchaseType = e.target.value

    this.refs.groupContent.classList[purchaseType === 'one-time' ? 'add' : 'remove']('hidden')

    if (purchaseType === 'one-time') {
      this.refs.sellingPlanInput.removeAttribute('name')
    } else {
      this.refs.sellingPlanInput.setAttribute('name', 'selling_plan')
    }
  }

  onVariantUpdate(variant) {
    const sellingPlanId = this.refs.sellingPlanInput.value
    const sellingPlan = (variant.selling_plan_allocations || []).find(p => p.selling_plan_id === +sellingPlanId)
    this.refs.compareAtPrice.forEach(el => el.innerHTML = this.formatMoney(sellingPlan.compare_at_price / 100))
    this.refs.price.forEach(el => el.innerHTML = this.formatMoney(sellingPlan.price / 100))
  }

  formatMoney(value) {
    return value.toLocaleString(this.dataset.locale, {
      style: 'currency',
      currency: this.dataset.currencyCode,
    })
  }
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPickerComponent);
}
